module.exports = __webpack_public_path__ + "img/9@2x.f85b2f87.png";